import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function toFormData(payload, imageFile) {
    const fd = new FormData();
    Object.entries(payload || {}).forEach(([key, value]) => {
        if (value === undefined) return;
        fd.append(key, value === null ? "" : String(value));
    });
    if (imageFile) fd.append("image", imageFile);
    return fd;
}

export default function usePartners() {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchPartners = useCallback(async (opts = {}) => {
        setLoading(true);
        setError("");
        try {
            const params = {};
            if (typeof opts.includeInactive === "boolean") params.include_inactive = opts.includeInactive;
            if (opts.q) params.q = opts.q;
            const res = await axios.get(`${API_BASE}/api/partners`, {
                withCredentials: true,
                params,
            });
            setPartners(res.data || []);
            return res.data || [];
        } catch (e) {
            setError(e?.response?.data?.error || e.message || "Partner laden fehlgeschlagen.");
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    const createPartner = useCallback(async (payload, imageFile = null) => {
        const res = await axios.post(`${API_BASE}/api/partners`, toFormData(payload, imageFile), {
            withCredentials: true,
        });
        await fetchPartners();
        return res.data.partner;
    }, [fetchPartners]);

    const updatePartner = useCallback(async (id, payload, imageFile = null) => {
        const res = await axios.put(`${API_BASE}/api/partners/${id}`, toFormData(payload, imageFile), {
            withCredentials: true,
        });
        await fetchPartners();
        return res.data.partner;
    }, [fetchPartners]);

    const deletePartner = useCallback(async (id) => {
        await axios.delete(`${API_BASE}/api/partners/${id}`, { withCredentials: true });
        await fetchPartners();
    }, [fetchPartners]);

    useEffect(() => {
        fetchPartners();
    }, [fetchPartners]);

    return {
        partners,
        loading,
        error,
        fetchPartners,
        createPartner,
        updatePartner,
        deletePartner,
    };
}
